(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-hero-hotspot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.c-hero');
    if (!section) {
      console.error('❌ [C-Hero] Section not found');
      return;
    }

    const hotspots = section.querySelectorAll('.c-hotspot');
    const closeButtons = section.querySelectorAll('[data-action="close-hotspot"]');

    // Function to check if we're in mobile view
    function isMobileView() {
      return window.innerWidth < 768;
    }

    // Handle hotspot click based on current screen size
    function handleHotspotClick(hotspot, trigger, modal, e) {
      e.preventDefault();
      e.stopPropagation();

      if (isMobileView()) {
        // Mobile: Open modal
        if (modal) {
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      } else {
        // Desktop: Toggle active class
        const isOpening = !hotspot.classList.contains('active');

        // Close other hotspots
        hotspots.forEach(function (other) {
          if (other !== hotspot) {
            other.classList.remove('active');
            other.style.visibility = isOpening ? 'hidden' : 'visible';
          }
        });

        // Toggle current hotspot
        hotspot.classList.toggle('active');

        if (!isOpening) {
          hotspots.forEach(function (other) {
            other.style.visibility = 'visible';
          });
        }
      }
    }

    // Attach click handlers to all hotspots
    hotspots.forEach(function (hotspot) {
      const trigger = hotspot.querySelector('.c-hotspot__trigger');
      const targetId = trigger.getAttribute('data-target');
      const modal = document.getElementById(targetId + '-modal');

      trigger.addEventListener('click', function (e) {
        handleHotspotClick(hotspot, trigger, modal, e);
      });
    });

    // Close hotspots when clicking outside (only affects desktop behavior)
    document.addEventListener('click', function (e) {
      if (!isMobileView() && !e.target.closest('.c-hotspot')) {
        hotspots.forEach(function (hotspot) {
          hotspot.classList.remove('active');
          hotspot.style.visibility = 'visible';
        });
      }
    });

    // Mobile modal close functionality
    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const targetId = this.getAttribute('data-target');
        const modal = document.getElementById(targetId + '-modal');

        if (modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    });

    // Close modal on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const openModals = section.querySelectorAll('.c-hotspot-modal.is-open');
        openModals.forEach(function (modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        });

        // Also close desktop hover cards
        hotspots.forEach(function (hotspot) {
          hotspot.classList.remove('active');
          hotspot.style.visibility = 'visible';
        });
      }
    });

    // Handle window resize - cleanup states when switching between mobile/desktop
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        // Close all modals
        const openModals = section.querySelectorAll('.c-hotspot-modal.is-open');
        openModals.forEach(function (modal) {
          modal.classList.remove('is-open');
        });

        // Reset desktop hover cards
        hotspots.forEach(function (hotspot) {
          hotspot.classList.remove('active');
          hotspot.style.visibility = 'visible';
        });

        // Reset body overflow
        document.body.style.overflow = '';
      }, 250); // Debounce resize events
    });

    // Handle color swatch clicks to change product images and variant

    hotspots.forEach(function (hotspot) {
      // Desktop swatches (in hover card)
      const desktopSwatches = hotspot.querySelectorAll(
        '[data-hotspot-swatches]:not([data-hotspot-swatches$="-mobile"]) .c-hotspot__swatch'
      );
      const desktopImageContainer = hotspot.querySelector(
        '[data-hotspot-image-container]:not([data-hotspot-image-container$="-mobile"])'
      );
      const desktopVariantInput = hotspot.querySelector(
        '[data-hotspot-variant-input]:not([data-hotspot-variant-input$="-mobile"])'
      );
      const desktopPriceCurrent = hotspot.querySelector(
        '[data-hotspot-price-current]:not([data-hotspot-price-current$="-mobile"])'
      );
      const desktopPriceCompare = hotspot.querySelector(
        '[data-hotspot-price-compare]:not([data-hotspot-price-compare$="-mobile"])'
      );

      desktopSwatches.forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const variantId = this.getAttribute('data-variant-id');
          const variantPrice = this.getAttribute('data-variant-price');
          const variantComparePrice = this.getAttribute('data-variant-compare-price');
          const variantPriceFormatted = this.getAttribute('data-variant-price-formatted');
          const variantComparePriceFormatted = this.getAttribute('data-variant-compare-price-formatted');

          // Remove active class from all swatches in this container
          desktopSwatches.forEach(function (s) {
            s.classList.remove('c-hotspot__swatch--active');
          });

          // Add active class to clicked swatch
          this.classList.add('c-hotspot__swatch--active');

          // Change image
          if (desktopImageContainer) {
            const currentVisible = desktopImageContainer.querySelector('.c-hotspot__img--visible');
            const newImage = desktopImageContainer.querySelector('[data-variant-id="' + variantId + '"]');

            if (currentVisible && newImage && currentVisible !== newImage) {
              currentVisible.classList.remove('c-hotspot__img--visible');
              currentVisible.style.display = 'none';
              newImage.style.display = 'block';
              // Force reflow
              void newImage.offsetWidth;
              newImage.classList.add('c-hotspot__img--visible');
            }
          }

          // Update form variant input
          if (desktopVariantInput && variantId) {
            desktopVariantInput.value = variantId;
          }

          // Update prices with formatted values
          if (desktopPriceCurrent && variantPriceFormatted) {
            desktopPriceCurrent.textContent = variantPriceFormatted;
          }

          if (desktopPriceCompare) {
            if (variantComparePrice && parseInt(variantComparePrice) > parseInt(variantPrice)) {
              desktopPriceCompare.textContent = variantComparePriceFormatted;
              desktopPriceCompare.style.display = 'inline';
            } else {
              desktopPriceCompare.style.display = 'none';
            }
          }
        });
      });

      // Mobile swatches (in modal) - need to query the modal directly since it's outside the hotspot
      const trigger = hotspot.querySelector('.c-hotspot__trigger');
      const targetId = trigger ? trigger.getAttribute('data-target') : null;
      const modal = targetId ? document.getElementById(targetId + '-modal') : null;

      if (modal) {
        const modalSwatches = modal.querySelectorAll('.c-hotspot__swatch');
        const modalImageContainer = modal.querySelector('[data-hotspot-image-container$="-mobile"]');
        const modalVariantInput = modal.querySelector('[data-hotspot-variant-input$="-mobile"]');
        const modalPriceCurrent = modal.querySelector('[data-hotspot-price-current$="-mobile"]');
        const modalPriceCompare = modal.querySelector('[data-hotspot-price-compare$="-mobile"]');

        modalSwatches.forEach(function (swatch) {
          swatch.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const variantId = this.getAttribute('data-variant-id');
            const variantPrice = this.getAttribute('data-variant-price');
            const variantComparePrice = this.getAttribute('data-variant-compare-price');
            const variantPriceFormatted = this.getAttribute('data-variant-price-formatted');
            const variantComparePriceFormatted = this.getAttribute('data-variant-compare-price-formatted');

            // Remove active class from all swatches in this container
            modalSwatches.forEach(function (s) {
              s.classList.remove('c-hotspot__swatch--active');
            });

            // Add active class to clicked swatch
            this.classList.add('c-hotspot__swatch--active');

            // Change image
            if (modalImageContainer) {
              const currentVisible = modalImageContainer.querySelector('.c-hotspot__img--visible');
              const newImage = modalImageContainer.querySelector('[data-variant-id="' + variantId + '"]');

              if (currentVisible && newImage && currentVisible !== newImage) {
                currentVisible.classList.remove('c-hotspot__img--visible');
                currentVisible.style.display = 'none';
                newImage.style.display = 'block';
                // Force reflow
                void newImage.offsetWidth;
                newImage.classList.add('c-hotspot__img--visible');
              }
            }

            // Update form variant input
            if (modalVariantInput && variantId) {
              modalVariantInput.value = variantId;
            }

            // Update prices with formatted values
            if (modalPriceCurrent && variantPriceFormatted) {
              modalPriceCurrent.textContent = variantPriceFormatted;
            }

            if (modalPriceCompare) {
              if (variantComparePrice && parseInt(variantComparePrice) > parseInt(variantPrice)) {
                modalPriceCompare.textContent = variantComparePriceFormatted;
                modalPriceCompare.style.display = 'inline';
              } else {
                modalPriceCompare.style.display = 'none';
              }
            }
          });
        });
      }
    });

    // 🎨 Limit Stamped Gallery to 3 visible items + "+X" bubble
    (function () {
      const observer = new MutationObserver(() => {
        const gallery = document.querySelector('.stamped-visual-gallery-feed');
        if (!gallery) return;

        const blocks = gallery.querySelectorAll('.stamped-visual-gallery-media-block');
        const loadMore = gallery.querySelector('.stamped-visual-gallery-nav');
        if (loadMore) loadMore.style.display = 'none'; // hide "Load more" button

        if (blocks.length) {
          // Show first 3, hide rest (keep DOM for modal logic)
          blocks.forEach((block, i) => {
            block.style.display = i < 4 ? 'block' : 'none';
          });

          const extraCount = blocks.length - 4;

          // Add "+X" bubble only once
          if (extraCount > 0 && !gallery.querySelector('.c-hero__extra-bubble')) {
            const bubble = document.createElement('div');
            bubble.className = 'c-hero__extra-bubble';
            bubble.textContent = `150K+`;
            gallery.appendChild(bubble);
          }

          observer.disconnect();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
